import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PasswordInput from '../components/PasswordInput';
import GradientSpinner from '../components/GradientSpinner';
import '../App.css';

const LAB_LOGO_KEY = 'labLogoUrl';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [labLogoUrl, setLabLogoUrl] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setLabLogoUrl(localStorage.getItem(LAB_LOGO_KEY));
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="App" style={{ height: '100vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="container" style={{ 
        maxWidth: '500px', 
        width: '100%',
        padding: window.innerWidth <= 768 ? '16px' : '24px',
        maxHeight: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        <div style={{ marginBottom: '12px' }}>
          <Link to="/" className="back-to-home-btn">
            <span className="back-to-home-icon">←</span>
            Back to home
          </Link>
        </div>
        <div className="card auth-screen" style={{ margin: 0 }}>
          <div className="text-center mb-3">
            <img 
              src={labLogoUrl || '/logo-labster.jpeg'} 
              alt={labLogoUrl ? 'Lab logo' : 'THE LABSTER'} 
              style={{ 
                maxWidth: window.innerWidth <= 768 ? '100px' : '120px', 
                width: '100%', 
                height: 'auto',
                marginBottom: '12px'
              }} 
            />
            <p className="page-subtitle" style={{ marginBottom: '16px' }}>{labLogoUrl ? 'Lab sign in' : 'Sign in to your account'}</p>
          </div>

          {error && <div className="alert alert-error" style={{ marginBottom: '12px' }}>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ marginBottom: '12px' }}>
              <label className="form-label" style={{ marginBottom: '6px', fontSize: '0.875rem' }} htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                className="form-input"
                value={formData.email}
                onChange={handleChange}
                required
                style={{ padding: '8px 12px', fontSize: '0.875rem' }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '12px' }}>
              <label className="form-label" style={{ marginBottom: '6px', fontSize: '0.875rem' }} htmlFor="login-password">Password</label>
              <PasswordInput
                id="login-password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete="current-password"
              />
            </div>

            <div style={{ marginBottom: '16px', textAlign: 'right' }}>
              <Link to="/forgot-password" style={{ color: '#33FFD9', fontSize: '0.8125rem' }}>
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', padding: '10px', fontSize: '0.875rem', marginBottom: '12px' }}
              disabled={loading}
            >
              {loading ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                  <GradientSpinner size={20} />
                  Signing in…
                </span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="text-center" style={{ marginTop: '12px' }}>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
              Don't have an account?{' '}
              <Link to="/register" style={{ color: '#33FFD9' }}>
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

